import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import { v2validations } from '../config/validation.config'
import type { HangupNodeData, SidebarComponentProps } from '../types'
import { GenericSidebarComponent } from './sidebar.base'

type FormValues = HangupNodeData['config']

const fields: () => GenericFieldConfig<FormValues> = () => [
  {
    name: 'name',
    componentType: 'input',
    label: 'Name',
    zodValidation: v2validations().hangup.shape.name,
    inputProps: {
      placeholder: 'Enter name',
    },
  },
  {
    name: 'reason',
    label: 'Hangup Reason',
    zodValidation: v2validations().hangup.shape.reason,
    componentType: 'select',
    inputProps: {
      options: [
        { value: 'busy', label: 'Busy' },
        { value: 'rejected', label: 'Rejected' },
      ],
      searchable: false,
    },
  },
]

export const HangupSidebarComponent = (props: SidebarComponentProps<HangupNodeData>) => (
  <GenericSidebarComponent fields={fields()} {...props} />
)
